/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { Button, Icon } from 'semantic-ui-react'



import DeleteModal from '../deleteComponent/deleteModal'
import DocumentHistoryModal from './documentHistoryModal'

const DocumentActionButton = (props) => {
    const [branchId, setbranchId] = useState('')
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    const [modalOpen, setmodalOpen] = useState(false)
    const [vehicle, setvehicle] = useState([])
    const [vehicleNo, setvehicleNo] = useState([])

    let handleClose = () => {
        setopenBox(false)
    }

    let handleDelete = () => {
        
    }

    let handleOpenEdit = (e) => {
        let mainData = props.data
        let history = props.agGridReact.props.BaseUrl.history
        console.log('open edit history: ', mainData)
        history.push({ pathname: '/edit-document/' +  mainData.vehicleid })
    }

    let handleOpenDelete = (e) => {
        let mainData = props.data
        setbranchId(mainData.id)
        setopenBox(true)
    }

    const handleHistoryCloseModal = (e) => {
        setmodalOpen(false)
    }

    const handleHistoryModal = (e) => {
        let mainData = props.data
        setvehicle(mainData.vehicleid)
        setvehicleNo(mainData.code)
        console.log('MainData', mainData)
        setmodalOpen(true)
    }

    let mainData = props.data                                                                                                                                                           
    return (
        <>
            <Button onClick={handleHistoryModal} basic size="mini" type="button" icon> <Icon name="history" color="blue" /></Button>
            <Button onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            {/* <Button disabled={mainData && mainData.statusId === 2 ? true : false || mainData && mainData.statusId === 3 ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button> */}
            {/* <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} /> */}
            { vehicle > 0 ? <DocumentHistoryModal modalOpen={modalOpen} handleClose={handleHistoryCloseModal} vehicle={vehicle ? vehicle : ''}  vehicleNo={vehicleNo} /> : null}
        </>
    )
}



export default DocumentActionButton